import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";

export default function OptionsDialog({ open, onClose, title, label, actions }) {

    return (
        <Dialog sx={{ zIndex: 9999 }} open={open} onClose={() => onClose(null)}>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <DialogContentText>
                    {label}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{
                justifyContent: "center",
                gap: 1,
                px: 2,
                pb: 2,
                flexShrink: 0,
            }}>
                {actions}

            </DialogActions>
        </Dialog>
    );
}